/* eslint-disable react/prop-types */
/* eslint-disable one-var */
/* eslint-disable no-prototype-builtins */
import React, {
    useState,
    useEffect,
    useContext,
    useRef,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
    get as _get,
} from 'lodash';

import { makeStyles, useTheme } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import InputAdornment from '@mui/material/InputAdornment';
import {
    DataGridPro,
    useGridApiRef,
} from '@mui/x-data-grid-pro';

import MenuIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';

import {
    ColumnRuleName,
    ColumnRulePurge,
    ColumnRuleEnable,
    ColumnRuleActions,
} from './columns';

import ConfirmationDialog from '../../../../components/confirmationdlg';
import { LoadingOverlay, NoRowsOverlay } from '../../../../components/xgrid/overlays';

import { ProfileContext } from '../../../../data/auth-service';
import SuricataService from '../../../../data/suricata-service';

import useWindowSize from '../../../../libraries/usewindowsize';

const useStyles = makeStyles(theme => ({
    root: {
        '& .columnHeader': {
            padding: '0 0 0 5px',
            height: 20,
            lineHeight: 20,
        },
    },
    suriSearch: {
        '& .MuiOutlinedInput-root': {
            borderTopRightRadius: '0px',
            borderBottomRightRadius: '0px',
        },
        '& input': {
            padding: '10px 14px',
        },
    },
    regexButton: {
        padding: '0px',
        minWidth: '30px',
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px',
    },
    filterButtons: {
        marginLeft: theme.spacing(2),
        '& button': {
            padding: '2px 2px',
            fontSize: '11px',
        }
    },
    tableContainer: {
        // I hate this but it works...
        '& .MuiDataGrid-main': {
            '& .MuiDataGrid-columnsContainer': {
                '& .MuiDataGrid-columnHeaderWrapper': {
                    maxHeight: '60px'
                },
            },
        },
    },
    detailPanel: {
        lineHeight: '30px',
        padding: '0 60px',
    },
    tooltipColor: {
        color: theme.palette.primary.contrastText,
    },
}));

const Rules = ({
    col,
    policy,
    groups,
    rules,
    updater,
    updateUpdater,
    ruleSearch,
    updateRuleSearch,
    getRules,
    getGroups,
    selectedGroup,
    // prevGroup,
    // updatePrev,
    revert,
    readonly,
    handleRuleSelection,
    managed,
    loading,
    updateSearchContext,
}) => {
    const theme = useTheme();
    const classes = useStyles();
    const navigate = useNavigate();
    // const location = useLocation();
    const [columns, setColumns] = useState([]);
    const [columnWidth, setColumnWidth] = useState({});
    const [ruleMenuAnchor, setRuleMenuAnchor] = useState(null);
    const [deleteRule, setDeleteRule] = useState('');
    const [otherPolicies, setOtherPolicies] = useState([]);
    const { updateProfile, getProfile } = useContext(ProfileContext);
    const { height } = useWindowSize();
    const rulesRef = useGridApiRef();
    const [ruleDetails, setRuleDetails] = useState([]);
    const [showRuleDetails, setShowRuleDetails] = useState(false);

    const selectedGroupRef = useRef();

    useEffect(() => {
        setColumnWidth(getProfile('suricata').groupWidths || {});
        // const queryParams = readRouteQuery();
        // updateRuleSearch(queryParams.search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (ruleSearch.search && showRuleDetails) {
            setRuleDetails(rules.rules.map(r => {
                return r.id;
            }));
        }

        if (!showRuleDetails) {
            setRuleDetails([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rules, showRuleDetails]);

    useEffect(() => {
        setColumns(generateColumns({}, managed));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [managed, rules]);

    // useEffect(() => {
    //     if (groups.groups.length) {
    //         getRules(ruleQuery);
    //     }
    //     ruleQueryRef.current = ruleQuery;
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [ruleQuery]);

    useEffect(() => {
        setColumns(generateColumns({ actions: {}, source: 'ui', stack: [] }, managed));
        if (rulesRef && rulesRef.current) {
            // Actual solution from MUI github issues with broken references, sync with timeout...
            setTimeout(() => {
                rulesRef.current.scroll({ top: 0 });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [revert]);

    useEffect(() => {
        // setRuleQuery({
        //     ...ruleQuery,
        //     page: 0,
        //     limit: 50,
        //     group: selectedGroup || '',
        //     search: ruleSearch,
        // });
        selectedGroupRef.current = selectedGroup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGroup]);

    useEffect(() => {
        if (deleteRule) {
            SuricataService.getRuleFromAllPolicies(deleteRule).then(res => {
                setOtherPolicies(res);
            });
        }
    }, [deleteRule]);

    // const readRouteQuery = () => {
    //     const routeQuery = new URLSearchParams(location.search);
    //     if (routeQuery.toString().length < 1) return {};
    //     return {
    //         group: routeQuery.has('group') ? routeQuery.get('group') : undefined,
    //         search: routeQuery.has('search') ? routeQuery.get('search') : undefined,
    //     };
    // };

    const generateColumns = (updatedMod, managed) => {
        const p = getProfile('suricata');
        let c = [
            {
                headerClassName: 'columnHeader',
                width: columnWidth.Rule || 0,
                ...!columnWidth.Rule ? { flex: 1 } : {},
                sortable: true,
                type: 'string',
                disableColumnMenu: true,
                hidden: false,
                headerName: 'Rule',
                field: 'name',
                renderCell: d => (
                    <ColumnRuleName
                        d={d}
                        theme={theme}
                        search={ruleSearch?.search}
                    />
                )
            },
            {
                headerClassName: 'columnHeader',
                width: _get(p, 'ruleWidths.Purge', 0),
                ...(_get(p, 'ruleWidths.Purge', 0) ? {} : { flex: 0.18 }),
                sortable: true,
                type: 'string',
                disableColumnMenu: true,
                hidden: false,
                headerName: 'Purge',
                field: 'keep',
                renderCell: d => (
                    <ColumnRulePurge
                        d={d}
                        updater={updater}
                        readonly={readonly}
                        handleRulePurge={handleRulePurge}
                    />
                ),
            },
            {
                headerClassName: 'columnHeader',
                width: _get(p, 'ruleWidths.Enable', 0),
                ...(_get(p, 'ruleWidths.Enable', 0) ? {} : { flex: 0.19 }),
                sortable: true,
                type: 'string',
                disableColumnMenu: true,
                hidden: false,
                headerName: 'Enable',
                field: 'enabled',
                renderCell: d => (
                    <ColumnRuleEnable
                        d={d}
                        updater={updater}
                        readonly={readonly}
                        handleRuleEnable={handleRuleEnable}
                    />
                ),
            },
            {
                headerClassName: 'columnHeader',
                width: _get(p, 'ruleWidths.Actions', 0),
                ...(_get(p, 'ruleWidths.Actions', 0) ? {} : { flex: 0.18 }),
                sortable: true,
                type: 'string',
                disableColumnMenu: true,
                hidden: false,
                headerName: '',
                field: ' ',
                renderCell: d => (
                    <ColumnRuleActions
                        d={d}
                        updater={updater}
                        readonly={readonly}
                        handleDeleteRuleDialog={handleDeleteRuleDialog}
                        handleCopyRule={handleCopyRule}
                        handleEditRule={handleEditRule}
                        managed={managed}
                    />
                ),
            },
        ];

        if (p.ruleColumns && p.ruleColumns.length) {
            c = p.ruleColumns.map(v => {
                for (let i = c.length; i--;) {
                    if (v === c[i].headerName) {
                        return c[i];
                    }
                }
                return v;
            });
        }

        return c;
    };

    const handleColumnResize = () => {
        const widths = rulesRef.current.getAllColumns().reduce((a, c) => {
            a[c.headerName] = c.width;
            return a;
        }, {});
        updateProfile('suricata', {
            ...getProfile('suricata'),
            ruleWidths: widths,
        });
        setColumnWidth(widths);
    };

    const handleColumnReorder = () => {
        let order = [];
        setTimeout(() => {
            order = rulesRef.current.getAllColumns().reduce((a, c) => {
                a.push(c.headerName);
                return a;
            }, []);

            updateProfile('suricata', {
                ...getProfile('suricata'),
                ruleColumns: order,
            });
        });
    };

    const handleRuleMenuOpen = (e) => {
        setRuleMenuAnchor(e.currentTarget);
    };

    const handleRuleMenuClose = () => {
        setRuleMenuAnchor(null);
    };

    const handleRuleSearch = (e) => {
        e.persist();
        updateRuleSearch({
            ...ruleSearch,
            search: e.target.value,
            page: 0,
        });
    };

    const handleRuleRegex = (e) => {
        updateRuleSearch({
            ...ruleSearch,
            exact: !ruleSearch?.exact,
        });
    };

    const handleUpdateRuleEnableFilter = (v) => {
        const r = { ...ruleSearch };
        if (v === 'enabled') {
            r.enabled = true;
        } else if (v === 'disabled') {
            r.enabled = false;
        } else {
            delete r.enabled;
        }
        r.page = 0;
        updateRuleSearch(r);
    };

    const handleUpdateRulePurgeFilter = (v) => {
        const r = { ...ruleSearch };
        if (v === 'gc_candidate') {
            delete r.keep;
            r.gc_candidate = true;
        } else if (v === 'keep') {
            delete r.gc_candidate;
            r.keep = true;
        } else {
            delete r.gc_candidate;
            delete r.keep;
        }
        r.page = 0;
        updateRuleSearch(r);
    };

    const handleEnableDisableAllRules = (status) => {
        const u = { ...updater };
        u.modifier_rule.enabled = status;
        u.page = 0;
        setTimeout(() => {
            updateSearchContext('rules');
            updateUpdater(u);
        });
        handleRuleMenuClose();
    };

    const handlePurgeAllRules = (status) => {
        const u = { ...updater };
        u.modifier_rule.keep = !status;
        u.page = 0;
        setTimeout(() => {
            updateSearchContext('rules');
            updateUpdater(u);
        });
        handleRuleMenuClose();
    };

    const handleRulePurge = (e, d) => {
        e.stopPropagation();
        e.preventDefault();

        const u = { ...updater };

        if (Object.prototype.hasOwnProperty.call(u.rules, d.row.id)) {
            u.rules[d.row.id].keep = !e.target.checked;
        } else {
            u.rules[d.row.id] = {
                keep: !e.target.checked,
            };
        }

        updateUpdater(u);
    };

    const handleRuleEnable = (e, d) => {
        e.stopPropagation();
        e.preventDefault();

        const u = { ...updater };

        if (Object.prototype.hasOwnProperty.call(u.rules, d.row.id)) {
            u.rules[d.row.id].enabled = e.target.checked;
        } else {
            u.rules[d.row.id] = {
                enabled: e.target.checked,
            };
        }

        updateUpdater(u);
    };

    const handleRowsScrollEnd = (e) => {
        if (rules && rules.rules.length && !(rules.rules % ruleSearch.limit)) {
            updateRuleSearch({
                ...ruleSearch,
                page: ruleSearch.page + 1,
            });
        }
    };

    const getRuleSortModel = () => {
        const ss = (ruleSearch.sort || 'name asc').split(' ');
        return [{ field: ss[0], sort: ss[1] }];
    };

    const handleOnRuleSort = s => {
        if (!s.length) {
            s = [{ field: 'name', sort: 'asc' }];
        }
        updateRuleSearch({
            ...ruleSearch,
            sort: `${s[0].field} ${s[0].sort}`,
            page: 0,
        });
    };

    const handleDeleteRule = () => {
        SuricataService.deleteRule(deleteRule).then(() => {
            getGroups();
            toast.success('Suricata rule deleted successfully');
            setDeleteRule('');
            setOtherPolicies([]);
        }, err => {
            console.error(err);
            toast.error('Failed to delete Suricata rule...');
            setDeleteRule('');
        });
    };

    const handleDeleteRuleDialog = (e, d) => {
        e.stopPropagation();
        e.preventDefault();

        if (typeof d === 'object') {
            setDeleteRule(d.row.id);
        } else {
            setDeleteRule('');
        }
    };

    const handleCopyRule = (e, d) => {
        e.preventDefault();
        e.stopPropagation();

        SuricataService.createCustomRule({
            action: d.row.action,
            header: d.row.header,
            message: d.row.name,
            options: d.row.options.replace(`msg:"${d.row.name}";`, '')
                .replace(`sid:${d.row.id};`, '')
                .replace(`rev:${d.row.ver};`, ''),
        }).then(res => {
            if (res.id) {
                navigate(
                    '/policies/suricata/rules/editor/' + res.id + `/${policy}`,
                    {
                        state: {
                            prevPath: `/policies/suricata/rules/${policy}`,
                        }
                    }
                );
            }
        });
    };

    const handleEditRule = (e, d) => {
        e.preventDefault();
        e.stopPropagation();

        if (d.row.id) {
            navigate(
                '/policies/suricata/rules/editor/' + d.row.id + `/${policy}`,
                {
                    state: {
                        prevPath: `/policies/suricata/rules/${policy}`,
                    }
                }
            );
        }
    };

    const handleClearSearch = () => {
        updateRuleSearch({
            ...ruleSearch,
            search: '',
            page: 0,
        });
    };

    const getDetailPanel = (d) => {
        if (ruleSearch.search && ruleDetails.length) {
            const t = 25;
            // const results = [];

            const results = Object.keys(d.row).map(k => {
                if (typeof d.row[k] === 'string') {
                    const m = d.row[k].match(new RegExp(ruleSearch.search, 'i'));
                    if (m) {
                        const r = d.row[k];
                        let s = k[0].toUpperCase() + k.substring(1) + ' - ';
                        if (m.index > t && r.length > ruleSearch.search.length + m.index + t) {
                            s += '...' + r.substring(m.index - t, m.index + ruleSearch.search.length + t) + '...';
                        } else if (m.index < t && r.length > ruleSearch.search.length + m.index + t) {
                            s += r.substring(0, m.index + ruleSearch.search.length + t) + '...';
                        } else if (m.index > t && r.length < ruleSearch.search.length + m.index + t) {
                            s += '...' + r.substring(m.index - t, r.length);
                        } else {
                            s += r;
                        }
                        return (<div key={'detail-result-' + k}>{s}</div>);
                    }
                }
                return null;
            });

            return (
                <Box className={classes.detailPanel}>
                    {results}
                </Box>
            );
        } else {
            return null;
        }
    };

    const handleShowDetails = () => {
        setShowRuleDetails(!showRuleDetails);
    };

    return (
        <Grid item xs={col}>
            <Paper elevation={3}>
                <Box p={2}>
                    <Box mb={1} display="flex" justifyContent="space-between">
                        <Typography variant="h6">Rules</Typography>
                        <Box display="flex" justifyContent="flex-start" className={classes.headerBorder}>
                            <ButtonGroup className={classes.filterButtons}>
                                <Button
                                    color="secondary"
                                    variant={(!ruleSearch.hasOwnProperty('gc_candidate') && !ruleSearch.hasOwnProperty('keep')) ? 'contained' : 'outlined'}
                                    aria-label="all rules"
                                    onClick={() => { handleUpdateRulePurgeFilter('all') }}
                                >All</Button>
                                <Button
                                    color="secondary"
                                    variant={ruleSearch.gc_candidate ? 'contained' : 'outlined'}
                                    aria-label="purge candidates only"
                                    onClick={() => { handleUpdateRulePurgeFilter('gc_candidate') }}
                                >Purge Candidates</Button>
                                <Button
                                    color="secondary"
                                    variant={ruleSearch.keep ? 'contained' : 'outlined'}
                                    aria-label="do not purge rules only"
                                    onClick={() => { handleUpdateRulePurgeFilter('keep') }}
                                >Do Not Purge</Button>
                            </ButtonGroup>
                            <ButtonGroup className={classes.filterButtons}>
                                <Button
                                    color="secondary"
                                    variant={!ruleSearch.hasOwnProperty('enabled') ? 'contained' : 'outlined'}
                                    aria-label="all rules"
                                    onClick={() => { handleUpdateRuleEnableFilter('all') }}
                                >All</Button>
                                <Button
                                    color="secondary"
                                    variant={ruleSearch.enabled ? 'contained' : 'outlined'}
                                    aria-label="enabled rules"
                                    onClick={() => { handleUpdateRuleEnableFilter('enabled') }}
                                >Enabled</Button>
                                <Button
                                    color="secondary"
                                    variant={(ruleSearch.hasOwnProperty('enabled') && !ruleSearch.enabled) ? 'contained' : 'outlined'}
                                    aria-label="disabled rules"
                                    onClick={() => { handleUpdateRuleEnableFilter('disabled') }}
                                >Disabled</Button>
                            </ButtonGroup>
                            {!readonly && <Box display="flex" justifyContent="flex-end">
                                <IconButton size="small" aria-label="rule menu" onClick={handleRuleMenuOpen}><MenuIcon /></IconButton>
                                <Menu anchorEl={ruleMenuAnchor} open={Boolean(ruleMenuAnchor)} onClose={handleRuleMenuClose}>
                                    <MenuItem onClick={() => { handleEnableDisableAllRules(true) }}>
                                        Enable All {selectedGroup ? `in ${selectedGroup}` : ''}
                                    </MenuItem>
                                    <MenuItem onClick={() => { handleEnableDisableAllRules(false) }}>
                                        Disable All {selectedGroup ? `in ${selectedGroup}` : ''}
                                    </MenuItem>
                                    <MenuItem onClick={() => { handlePurgeAllRules(false) }}>
                                        Do Not Purge All {selectedGroup ? `in ${selectedGroup}` : ''}
                                    </MenuItem>
                                    <MenuItem onClick={() => { handlePurgeAllRules(true) }}>
                                        Purge All {selectedGroup ? `in ${selectedGroup}` : ''}
                                    </MenuItem>
                                </Menu>
                            </Box>}
                        </Box>
                    </Box>
                    <Box display="flex" mb={1}>
                        <TextField
                            className={classes.suriSearch}
                            fullWidth
                            variant="outlined"
                            placeholder="Search rules"
                            onChange={handleRuleSearch}
                            value={ruleSearch?.search || ''}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <Tooltip title="Clear search" classes={{ tooltip: classes.tooltipColor }}>
                                            <IconButton size="small" onClick={handleClearSearch}>
                                                <CloseIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <Tooltip classes={{ tooltip: classes.tooltipColor }} title="Regular expression search"><Button  className={classes.regexButton} variant={!ruleSearch?.exact ? 'contained' : 'outlined'} aria-label="regex search" color="primary" onClick={handleRuleRegex}>.*</Button></Tooltip>
                        <Tooltip classes={{ tooltip: classes.tooltipColor }} title="Rule metadata search"><Button  className={classes.regexButton} variant={showRuleDetails ? 'contained' : 'outlined'} aria-label="show rule search details" color="primary" onClick={handleShowDetails}>+</Button></Tooltip>
                    </Box>
                    <Box className={classes.root} height={height - 350}>
                        <DataGridPro
                            apiRef={rulesRef}
                            rows={rules.rules}
                            columns={columns}
                            disableMultipleSelection
                            onSelectionModelChange={handleRuleSelection}
                            // sortingMode={'server'}
                            sortingOrder={['desc', 'asc']}
                            onSortModelChange={handleOnRuleSort}
                            sortModel={getRuleSortModel()}
                            onColumnResizeCommitted={handleColumnResize}
                            onColumnOrderChange={handleColumnReorder}
                            onRowsScrollEnd={handleRowsScrollEnd}
                            components={{
                                Footer: () => (<div></div>),
                                DetailPanelCollapseIcon: () => (<div></div>),
                                DetailPanelExpandIcon: () => (<div></div>),
                                LoadingOverlay: LoadingOverlay,
                                NoRowsOverlay: NoRowsOverlay,
                            }}
                            disableVirtualization
                            loading={loading && !rules?.rules.length}
                            detailPanelExpandedRowIds={ruleDetails}
                            getDetailPanelContent={getDetailPanel}
                            getDetailPanelHeight={(d) => {
                                const results = Object.keys(d.row).map(k => {
                                    if (typeof d.row[k] === 'string') {
                                        const m = d.row[k].match(new RegExp(ruleSearch.search, 'i'));
                                        if (m) return k;
                                    }
                                    return null;
                                }).filter(f => f);

                                return results.length * 30;
                            }}
                            classes={{
                                detailPanelToggleCell: {
                                    display: 'none',
                                },
                                'detailPanelToggleCell--expanded': {
                                    display: 'none',
                                },
                            }}
                            columnVisibilityModel={{
                                __detail_panel_toggle__: false,
                            }}
                        />
                    </Box>
                </Box>
            </Paper>
            <ConfirmationDialog
                onClose={handleDeleteRuleDialog}
                onOK={handleDeleteRule}
                open={!!deleteRule}
                message={(() => {
                    let ruleName = '',
                        polList = [];

                    if (deleteRule) {
                        const i = rules.rules.findIndex(v => v.id === deleteRule);
                        ruleName = rules.rules[i].name;
                    }

                    polList = otherPolicies.map((v, i) => {
                        if (v.enabled && v.group_enabled) {
                            return (
                                <Typography key={'other-rule-policy-' + i} color="secondary">
                                    Suricata Rules ({v.policy})
                                </Typography>
                            );
                        }
                        return null;
                    }).filter(v => v);

                    return (
                        <React.Fragment>
                            <Typography>
                                Are you sure you would like to delete the rule
                            </Typography>
                            <Box mt={1} ml={2}>
                                <Typography color="secondary">{ruleName}</Typography>
                            </Box>
                            <Box mt={2} display={polList.length ? 'block' : 'none'}>
                                <Typography>This rule is used in:</Typography>
                            </Box>
                            <Box mt={2} display={polList.length ? 'none' : 'block'}>
                                <Typography>This rule is not currently used by other Suricata policies.</Typography>
                            </Box>
                            <Box mt={1} ml={2}>
                                {polList}
                            </Box>
                        </React.Fragment>
                    );
                })()}
                title="Delete Rule"
                cancelLabel="Cancel"
                okLabel="Yes"
            />
        </Grid>
    );
};

export default Rules;
